import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL_API } from '../global/config';
import { Sector } from '../models/Sector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'


@Injectable({
  providedIn: 'root'
})
export class SectorDetalleService {

  private sector: Sector;
  private urlEndpoint: string = URL_API.UrlApi + '/api/v1/sectores';

  constructor(
    private http: HttpClient
  ) { }

  getDetalleSector(codSector: string): Observable<Sector>{
    return this.http.get(this.urlEndpoint+'/cod/'+codSector).pipe(
      map( (response) => response as Sector)
    )

  }

}
